// extracted by mini-css-extract-plugin
export default {"root":"CopyFooter_root__3xYB6","content":"CopyFooter_content__g75at"};